import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';

export function toDate(value: string | number | Dayjs | undefined) {
	return value ? dayjs(value).toDate() : value;
}
